import type { SncrConselho } from "../types";
import { SNCR_CONSELHOS } from "../constants";

export function parsePractitionerClassId(classId?: string | null): {
  conselho?: SncrConselho;
  uf?: string;
  documento?: string;
} {
  if (!classId?.trim()) return {};

  const [rawConselho, rest = ""] = classId.trim().split("/");
  const conselho = SNCR_CONSELHOS.find(
    (item) => item === rawConselho?.toUpperCase(),
  );
  const uf = rest.slice(0, 2).toUpperCase() || undefined;
  const documento = rest.slice(2).replace(/\D/g, "") || undefined;

  return { conselho, uf, documento };
}
